export default __webpack_public_path__ + "static/media/lowRisk.21d26996.svg";